var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoCallAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 7.875,
    fill: "#7ED321",
    stroke: "white",
    strokeWidth: 1.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99805 8.29033C5.99805 7.74004 6.41936 7.29395 6.93908 7.29395H9.99743C10.5171 7.29395 10.9385 7.74004 10.9385 8.29033V10.5322C10.9385 11.0825 10.5171 11.5286 9.99743 11.5286H6.93908C6.41936 11.5286 5.99805 11.0825 5.99805 10.5322V8.29033Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9385 8.80281L12.35 8.04124V10.7813L10.9385 10.0197V8.80281Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99805 8.29033C5.99805 7.74004 6.41936 7.29395 6.93908 7.29395H9.99743C10.5171 7.29395 10.9385 7.74004 10.9385 8.29033V10.5322C10.9385 11.0825 10.5171 11.5286 9.99743 11.5286H6.93908C6.41936 11.5286 5.99805 11.0825 5.99805 10.5322V8.29033Z",
    stroke: "black",
    strokeWidth: 0.470516,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9385 8.80281L12.35 8.04124V10.7813L10.9385 10.0197V8.80281Z",
    stroke: "black",
    strokeWidth: 0.470516,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCallAvailable);
export default __webpack_public_path__ + "static/media/video-call-available.a773d13e4886521f501f83b0f91b6796.svg";
export { ForwardRef as ReactComponent };